import { Skeleton } from '@writefull/ui'

import AiResult from './AiResult'

type AiResultSkeletonProps = Parameters<typeof Skeleton>[0]

export default function AiResultSkeleton(props: AiResultSkeletonProps) {
  return (
    <AiResult copyDisabled>
      <Skeleton {...props} />
    </AiResult>
  )
}
